var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#000A0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.847a2.286 2.286 0 0 0-.674-1.6l-4.903-4.915a1.143 1.143 0 1 0-1.612 1.623l3.76 3.749H9.143a1.143 1.143 0 1 0 0 2.285H20.57l-3.76 3.76a1.143 1.143 0 1 0 1.612 1.623l4.903-4.914c.429-.427.671-1.006.674-1.611Z",
    fill: "#fff"
  })));
};
export default SvgRightArrow;